import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import NavBar from "../components/Navigation/NavBar";
import MainContainer from "../components/MainContainer";
import { setHeader } from "../redux/slices/headerSlice";
import { HOME_PATH, SUBSCRIPTION_PATH } from "../utility/path";
import { displayDateTime, getConstant, getSubscriptionStatusLabel, handleHeader } from "../services/functions";
import CustomIcon from "../components/CustomIcon";
import { getTransactionStatusStyle } from "../utility/colorUtils";
import "../SubscriptionDetails.css"
import { useNavigate } from "react-router-dom";
import { getTransactionStatusKey } from "../utility/transactionUtils";

const SubscriptionDetails = ({ }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const payment = useSelector((state) => state.payment.data);
    const authData = useSelector((state)=> state.auth.data);
    const statusKey = getTransactionStatusKey(payment?.subscriptionStatus, payment?.state);
    // Inside component — useMemo prevents re-randomizing on every render
    const cfg = useMemo(() => getTransactionStatusStyle(statusKey), []);

    console.log('payment',payment);
    
    useEffect(() => {
        handleHeader({...getConstant("SUBSCRIPTION_DETAILS")},dispatch);
        
        return () => { dispatch(setHeader({ gotoName: "Subscription", gotoAction: SUBSCRIPTION_PATH })); }
    }, []);

    const onHome = async (event) => {
        if (event) event.preventDefault(); // Ensure event exists before calling preventDefault()
        navigate(SUBSCRIPTION_PATH);
    }

    const onTry = async (event) => {
        if (event) event.preventDefault(); // Ensure event exists before calling preventDefault()
        navigate(SUBSCRIPTION_PATH);
    }

    return (
        <> 
            <NavBar />
            <MainContainer>

                <div className="txs-card">
                    {/* Status header */}
                    <div className="txs-header" style={{ background: cfg?.headerBg, borderBottomColor: cfg?.headerBorder }}>
                        <div className="txs-icon" style={{ background: cfg?.iconBg, borderColor: cfg?.iconBorder }}>
                            <i className={`fa ${cfg?.icon}`} style={{ color: cfg?.iconColor }} />
                        </div>
                        <p className="txs-title" style={{ color: cfg.titleColor }}>{cfg.title}</p>
                        <p className="txs-subtitle" style={{ color: cfg.subtitleColor }}>{cfg.subtitle}</p>
                    </div>

                    {/* Details */}
                    <div className="txs-details">
                        {payment?.transactionId && (
                            <div className="txs-row">
                                <span className="txs-row__label">Transaction ID</span>
                                <span className="txs-row__value">{payment.transactionId}</span>
                            </div>
                        )}
                        {payment?.amount && (
                            <div className="txs-row">
                                <span className="txs-row__label">Amount</span>
                                <span className="txs-row__value">
                                    <CustomIcon type="currency" />{payment.amount}
                                </span>
                            </div>
                        )}
                        <div className="txs-row">
                            <span className="txs-row__label">Status</span>
                            <span
                                className="txs-row__pill"
                                style={{ background: cfg.pillBg, color: cfg.pillColor }}
                            >
                                {cfg.pillLabel}
                            </span>
                        </div>

                        {payment?.subscriptionEndDate && (
                            <div className="txs-row">
                                <span className="txs-row__label">Expires</span>
                                <span className="txs-row__value">
                                    {new Date(payment.subscriptionEndDate).toLocaleDateString()}
                                </span>
                            </div>
                        )}
                        {payment?.updatedAt && !payment?.subscriptionEndDate && (
                            <div className="txs-row">
                                <span className="txs-row__label">Date</span>
                                <span className="txs-row__value">
                                    {new Date(payment.updatedAt).toLocaleString()}
                                </span>
                            </div>
                        )}
                    </div>

                     {/* Pending note */}
                      {statusKey === "pending" && (
                        <div className="txs-note">
                            <i className="fa fa-info-circle" style={{ color: "#0891b2" }} />
                            If amount was deducted, it will be refunded within 5-7 business days.
                        </div>
                    )}

                     {/* Actions */}
                    <div className="txs-actions">
                        {statusKey === "success" && (
                            <button className="txs-btn txs-btn--primary" onClick={onHome}>
                                Go to Home
                            </button>
                        )}
                        {statusKey === "error" && (
                            <>
                                {/* <button className="txs-btn txs-btn--secondary" onClick={()=> {}}>
                                    Contact Us
                                </button> */}
                                <button className="txs-btn txs-btn--primary" onClick={onTry}>
                                    Try Again
                                </button>
                            </>
                        )}
                        {statusKey === "pending" && (
                            <button className="txs-btn txs-btn--secondary" onClick={onHome}>
                                Go to Home
                            </button>
                        )}
                    </div>
                </div>
            </MainContainer>
        </>
    );
}

export default SubscriptionDetails;
